import React, { useEffect, useState } from "react";
import TitleBar from "../../common/title-bar/title-bar";
import Button from "../../common/button/button";
import TableOptionsCell from "../../common/table/table-options-cell";
import Table from "../../common/table";
import { useParams } from "react-router-dom";
import { exportToCSV } from "../Utils/ExcelExports";
import APIService from "../../Service/APIService";
import "./CommissionStatementsCss.css";
import { useNavigate } from "react-router-dom";
import TableLink from "../../common/table/table-link";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Flex } from "antd";
import dayjs from "dayjs";
import { useAuth } from "../AuthProvider.js";
import { canAccessCommissionsPage } from "./commissionPageAccess.js";
import Swal from "sweetalert2";
import { colors } from "../../theme/colors";

const CommissionStatementsDetails = () => {
  const { user } = useAuth();
  const userData = user;
  //   const { id } = useParams();
  const navigate = useNavigate();
  const { id } = useParams();
  // const [statementDate, setStatementDate] = useState("");
  const [statementData, setStatementData] = useState(null);
  const [statement, setStatement] = useState([]);
  const [downloadLoadingStates, setDownloadingLoadingStates] = useState({});
  const [loading, setLoading] = useState(true);
  var JSZip = require("jszip");
  let zip = new JSZip();

  const getData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getcommissionsbystatementmonth?ID=${id}`
    );
    console.log("getData", response.data);
    return response?.data || [];
  };

  useEffect(() => {
    // dummyCommissionStatements.find((el) => {
    //   if (el.ID === Number(id)) {
    //     setStatementDate(el.StatementDate);
    //   }
    // });
    if (userData && !canAccessCommissionsPage(userData)) {
      if (userData.Type === "Account") {
        navigate(`/Account/${userData.AccountID}`);
      } else if (userData.Type === "Distributor") {
        navigate(`/Distributor/${userData.DistributorID}`);
      } else {
        navigate("/");
      }
      return;
    }
    getData().then((data) => {
      setStatementData(data.data || []);
      setStatement(data.Statement || []);
      setLoading(false);
    });
  }, [id]);

  const downloadPDF = async (data, statementID) => {
    setDownloadingLoadingStates(prev => ({ ...prev, [data?.DistributorID]: true }));
    try {
      const apiServe = new APIService();
   
      const response = await apiServe.getGeneratedFile(
        {
          statementID: statementID || null,
          distID: data?.DistributorID || null,
        },
        "generateCommissionPDFDist"
      );

      if (response) {
        // get the response as a blob
        const pdfBlob = await response.data;
        
        // check if the server sent a PDF. If not, log the error message inside the blob.
        if (pdfBlob.type !== 'application/pdf') {
          const errorText = await pdfBlob.text(); // Read the blob as text
          console.error('Server did not return a PDF. Response body:', errorText);
          alert('Failed to generate PDF. Check the console for server error message.');
          // setLoadingInvoices(prev => ({ ...prev, [invoiceId]: false }));
          return; // stop execution
        }

        // create a temporary URL for the blob
        const url = window.URL.createObjectURL(pdfBlob);

        // ceate a temporary link element to trigger the download
        const link = document.createElement('a');
        link.href = url;
        const stateMonthYearProcessed = statement.StatementMonthYear.replace(/ /g, '-');
        link.setAttribute('download', `${data?.DistributorName}-Commission-Statement-for-${stateMonthYearProcessed}.pdf`);
        document.body.appendChild(link);
        link.click();

        // clean up by removing the link and revoking the URL
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Failed to download PDF:", error);
    } finally {
      setDownloadingLoadingStates(prev => ({ ...prev, [data?.DistributorID]: false }));
    }
  };

  const exportColumns = [
    { key: "DistributorName", header: "Distributor" },
    { key: "InvoiceCount", header: "Invoices" },
    { key: "TotalCommissionApplied", header: "Total Commission Applied", transform: (v) => Number(v ?? 0).toFixed(2), },
    { key: "TotalCommissionReceived", header: "Total Commission Received", transform: (v) => Number(v ?? 0).toFixed(2), },
    { key: "TotalCommissionDue", header: "Total Commission Due", transform: (v) => Number(v ?? 0).toFixed(2), },
    { key: "TotalReferralCommission", header: "Total Referral Commission", transform: (v) => Number(v ?? 0).toFixed(2), },
  ];

  const handleDownloadSummary = async () => {
    exportToCSV(statementData, "Commission Summary", exportColumns);
  }

  const exportCommissionsColumns = [
    { key: "AccountName", header: "Account" },
    { key: "ManufacturerName", header: "Manufacturer" },
    { key: "DistributorName", header: "Distributor" },
    { key: "InvoiceID", header: "Invoice ID" },
    { key: "ProductGroupID", header: "ProductGroupID" },
    { key: "ProductGroupName", header: "Product Group" },
    { key: "Price", header: "Price", transform: (v) => Number(v ?? 0).toFixed(2), },
    { key: "TissueID", header: "Tissue ID" },
    { key: "DateApplied", header: "Date Applied", transform: (v) => dayjs(v).format("MM-DD-YYYY"), },
    { key: "Received", header: "Received", transform: (v) => Number(v ?? 0).toFixed(2), },
    { key: "Balance", header: "Balance",  transform: (v) => Number(v ?? 0).toFixed(2), },
    { key: "DistributorCommissionPercentage", header: "Distributor Commission Percentage" },
    { key: "ReferralDistributorID", header: "Referral DistributorID" },
    { key: "ReferralDistributorName", header: "Referral Distributor" },
    { key: "ReferralCommissionPercentage", header: "Referral Commission Percentage", transform: (v) => Number(v ?? 0).toFixed(2) },
    { key: "ReferralCommission", header: "Referral Commission", transform: (v) => Number(v ?? 0).toFixed(2) },

  ];

  const handleExportCommissions = async () => {
    setLoading(true);
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`GetCommissionsInDateRange?StatementID=${statement?.ID}`);
    if (response && response.data) {
      await exportToCSV(response?.data?.data, "Commissions", exportCommissionsColumns);
      setLoading(false);
    }
    // GetCommissionsInDateRange
    // exportToCSV(statementData, "Commission Statements Details", exportColumns);
  }

  const publishAndNotify = async (data) => {
    if (!statement?.IsGenerated) return;
    Swal.fire({
      title: "Publish Statement",
      text: "Are you sure you would like to publish this commission statement to this distributor? This statement will be available to distributor, and the distributor managers will be notified of the same via email.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoading(true);
      try {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend(
          {
            CommissionStatementID: id,
            DistributorID: data?.DistributorID,
          },
          "PublishCommissionStatementDistributor"
        );
        if (response?.status === 200 || response?.status === 201) {
          const updated = await getData();
          setStatementData(updated.data || []);
          setStatement(updated.Statement || []);
          setLoading(false);
          Swal.fire(
            "Success!",
            "Commission Statement published successfully.",
            "success"
          );
        } else {
          setLoading(false);
          Swal.fire(
            "Error",
            response?.data?.message ||
              "Something went wrong while publishing the commission statement.",
            "error"
          );
        }
      } catch (error) {
        console.error("Failed to publish commission statement", error);
        setLoading(false);
        Swal.fire(
          "Error",
          "Something went wrong while publishing the commission statement.",
          "error"
        );
      }
    });
  };

  const tableHeadersCommissionsStatementsDetails = [
    {
      headerName: "Distributor",
      field: "DistributorName",
      filter: true,
      cellRenderer: (params) => {
        return (
          <TableLink
            value={params.data.DistributorName}
            path={`/Distributor/${params.data.DistributorID}`}
          />
        );
      },
    },
    {
      headerName: "Invoices",
      field: "InvoiceCount",
      filter: true,
    },
    {
      headerName: "Total Comm. Applied",
      field: "TotalCommissionApplied",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params?.data?.TotalCommissionApplied).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.TotalCommissionApplied).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Total AS Comm. Recd.",
      field: "TotalCommissionReceived",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params?.data?.TotalCommissionReceived).replace(
            /[^0-9.-]+/g,
            ""
          )
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.TotalCommissionReceived).replace(
            /[^0-9.-]+/g,
            ""
          )
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Total Distributor Comm. Due",
      field: "TotalCommissionDue",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params?.data?.TotalCommissionDue).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.TotalCommissionDue).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Total Referral Comm.",
      field: "TotalReferralCommission",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params?.data?.TotalReferralCommission).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.TotalReferralCommission).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Options",
      field: "",
      sortable: false,
      cellRenderer: (params) => {
        const isPublished = Boolean(params.data?.IsPublished);
        const canPublish = Boolean(statement?.IsGenerated) && !isPublished;
        return (
          <TableOptionsCell
            optionOne={canPublish ? "Publish and Notify" : ""}
            optionOneType={canPublish ? "primary" : ""}
            optionOneClickFn={canPublish ? publishAndNotify : undefined}
            optionDownloadButton="Download"
            optionDownloadButtonType="primary"
            optionDownloadButtonClickFn={async () => await downloadPDF(params.data, id)}
            optionDownloadButtonLoading={downloadLoadingStates[params.data?.DistributorID] || false}
            optionTwo="View"
            optionTwoType="warning"
            optionTwoClickPath={`/CommissionStatementsDistributor/${params.data.DistributorID}`}
            rowData={params.data}
            moreData={{ CommissionStatementID: id, IsGenerated: statement?.IsGenerated }}
            type="CommissionStatementsDetails"
          />
        );
      },
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      {statement != null &&
        <>
          <TitleBar
            entityName="Commissions Applied by Distributor"
            label={`Commission Statement ${statement?.StatementMonthYear}`}
            rightFilterBarComponents={
              <>
                <Button variant="primary" onClick={handleExportCommissions}>Export</Button>
                <Button variant="primary" onClick={handleDownloadSummary}>Download Summary</Button>
              </>
            }
          />
          <Table
            rowData={statementData}
            columnDefs={tableHeadersCommissionsStatementsDetails}
          />
        </>
      }
    </div>
  );
};

export default CommissionStatementsDetails;
